import { render, staticRenderFns } from "./PermissionProduct.vue?vue&type=template&id=ee428088"
import script from "./PermissionProduct.vue?vue&type=script&lang=js"
export * from "./PermissionProduct.vue?vue&type=script&lang=js"
import style0 from "./PermissionProduct.vue?vue&type=style&index=0&id=ee428088&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports